module.exports = "/images/global-spinner.svg?85301ec7f5bc3fe202597123ecdcd92f";